export const vehicalInspectionList = [
  {
    key: 'goodVisibility',
    label: 'Good visibility for driver through cab windows and mirrors. All required mirrors fitted and adjusted correctly.',
  },
  { key: 'drivingControlsSeat', label: 'Driving controls, seat and driver safety belt adjusted correctly.' },
  { key: 'windscreenWasherWipers', label: 'Windscreen washer, wipers, demister and horn operating correctly.' },
  { key: 'tachographCalibrated', label: 'Tachograph calibrated with correct hours. Speed limiter plaque displayed.' },
  {
    key: 'allInstruments',
    label:
      'All instruments, gauges and other warning devices operating correctly (including ABS/EBS in-cab warning lights).',
  },
  { key: 'noAirleaksOrPressureDrop', label: 'No air leaks or pressure drop.' },
  { key: 'vehicleSittingSquare', label: 'Vehicle sitting square and not leaning to one side.' },
  {
    key: 'taxInsurance',
    label: 'Tax, insurance and transport discs (if applicable) present and valid. Number plates clearly visible.',
  },
  {
    key: 'wheelsGoodCondition',
    label: 'Wheels in good condition and secure. Tyres undamaged with correct inflation and tread depth.',
  },
  { key: 'allLightsReflectors', label: 'All lights, reflectors and markings fitted, clean and in good condition.' },
  { key: 'exhaustSecure', label: 'Exhaust secure with no excess noise or smoke.' },
  { key: 'airElectrical', label: 'Air & electrical suzies and connectors fitted correctly (inc. ABS / EBS cable).' },
  { key: 'vehicleAccess', label: 'Vehicle access, steps, catwalk or drawbar coupling in good condition.' },
  {
    key: 'vehicleBody',
    label: 'Vehicle body / wings / guards, side and rear / curtains and straps / doors / tail lift in good condition.',
  },
  { key: 'fifthWheel', label: 'Fifth wheel located and locked correctly, landing legs and handle in correct position.' },
  { key: 'trailerParkBrake', label: 'Trailer park brake operating correctly.' },
  { key: 'airSuspension', label: 'Air suspension correctly set.' },
  { key: 'engineOil', label: 'Engine oil, water, windscreen washer reservoir and fuel levels checked and no leaks.' },
  { key: 'steeringAndBrakes', label: 'Steering and brakes operating correctly.' },
  { key: 'loadsSecured', label: 'Loads secured and weight distributed correctly.' },
  { key: 'tachographSpeedometer', label: 'Tachograph, speedometer and speed limiter operating correctly.' },
  { key: 'abSandEBS', label: 'ABS/EBS warning lights off.' },
  { key: 'other', label: 'Other - Weekly Check of Crane if Applicable' },
  { key: 'checkRolloverCovers', label: 'Check rollover covers, cover sheet stop, straps ratchets.' },
];

export const harvestingMaintanceVehicalCheckListoptionList = [
  {
    key: 'harvestingMaintenanceFillDiesel',
    label: 'Fill Diesel',
  },
  {
    key: 'harvestingMaintenanceGreaseHeads',
    label: 'Grease Heads',
  },
  {
    key: 'harvestingMaintenanceGreaseCrane',
    label: 'Grease Crane',
  },
  {
    key: 'harvestingMaintenanceGreaseBaseUnit',
    label: 'Grease Base Unit',
  },
  {
    key: 'harvestingMaintenanceCheckEngineOilLevel',
    label: 'Check Engine Oil Level',
  },
];
